module.exports = __webpack_public_path__ + "static/media/USDBlack.cc6c79f9.png";